import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Triangle, ShieldCheck } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@confidence.com");
  const [password, setPassword] = useState("Confidence@2026");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha no login. Verifique e-mail e senha.");
    } finally { setLoading(false); }
  };

  const demoLogin = async () => {
    setLoading(true);
    setEmail("admin@confidence.com");
    setPassword("Confidence@2026");
    try {
      await login("admin@confidence.com", "Confidence@2026");
      navigate("/app");
    } catch (err) {
      toast.error("Falha no acesso demo: " + (err?.response?.data?.detail || err?.message || "erro"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      {/* Left brand panel */}
      <div className="bg-[#0A3B2C] text-white p-12 flex flex-col justify-between bg-grid relative">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 border-2 border-white flex items-center justify-center">
            <Triangle size={22} weight="bold" />
          </div>
          <div className="font-heading font-bold text-xl">Confidence Brand Monitor</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-white/50 mb-4">Inteligência de marca</div>
          <h1 className="font-heading font-extrabold text-4xl lg:text-5xl leading-tight mb-6">
            Proteja sua marca.<br/>Monitore sua reputação.
          </h1>
          <p className="text-white/70 max-w-md text-sm leading-relaxed">
            Ferramenta profissional de monitoramento contínuo para marcas registradas.
            Identifica nomes semelhantes, logos parecidos e depósitos no INPI que podem gerar conflito.
          </p>
          <div className="mt-8 flex items-center gap-3 text-xs text-white/60">
            <ShieldCheck size={16} weight="bold" />
            Esta plataforma é informativa e não substitui análise jurídica especializada.
          </div>
        </div>
        <div className="text-xs text-white/40">© 2026 Confidence Contabilidade</div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 lg:p-12 bg-white">
        <Card className="w-full max-w-md p-8 border rounded-sm">
          <h2 className="font-heading font-bold text-2xl mb-1">Acessar plataforma</h2>
          <p className="text-sm text-muted-foreground mb-6">Entre com seu e-mail corporativo.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider">E-mail</Label>
              <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-sm mt-1" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider">Senha</Label>
              <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-sm mt-1" />
            </div>
            <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full rounded-sm bg-[#0A3B2C] hover:bg-[#083527] text-white">
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>
          <div className="mt-6 text-xs text-muted-foreground">
            Novo por aqui? <Link to="/registrar" className="text-[#0A3B2C] font-semibold underline">Criar conta</Link>
          </div>
          <div className="mt-6 p-3 bg-[#F0FDF4] border border-[#0A3B2C]/20 rounded-sm">
            <div className="text-xs font-semibold mb-1 text-[#0A3B2C]">Acesso rápido para demonstração</div>
            <div className="text-[11px] text-muted-foreground mb-2 font-mono">admin@confidence.com / Confidence@2026</div>
            <Button
              type="button"
              data-testid="demo-login-btn"
              onClick={demoLogin}
              disabled={loading}
              variant="outline"
              className="w-full rounded-sm border-[#0A3B2C] text-[#0A3B2C] hover:bg-[#0A3B2C] hover:text-white"
            >
              Entrar em modo demonstração
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
